import { createFileRoute, Link } from '@tanstack/react-router';
import { GroupList } from '../../components/groups/group-list';

export const Route = createFileRoute('/groups/')({
  component: Component,
});

function Component() {
  return (
    <main
      aria-label='Groups'
      className='mx-auto max-w-4xl px-4 py-6 sm:px-6 sm:py-8'
    >
      <div className='mb-5 flex items-center justify-between gap-4'>
        <h1 className='text-xl font-semibold tracking-tight text-c-text'>
          Groups
        </h1>
        <Link
          to='/groups/create'
          className='inline-flex shrink-0 items-center rounded-lg bg-c-accent px-3 py-2 text-sm font-semibold text-[#2f2418] shadow-sm transition-all hover:-translate-y-0.5 hover:bg-c-accent-hover hover:shadow focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-c-accent motion-reduce:transform-none'
        >
          + Create Group
        </Link>
      </div>
      <GroupList />
    </main>
  );
}
